<template>
    <img
        class="decree-marker"
        :class="{['selected']: selected}"
        :src="decreeMarkerImg"
    />
</template>

<script>
import {
    THEME_TOURNAMENT_KIT,
} from '../Game/Game-types';
import decreeMarkerWhite from '../../assets/decree_marker_white.png';
import decreeMarkerWhiteOutlined from '../../assets/decree_marker_white_outline.png';
import decreeMarkerWhiteAlt from '../../assets/decree_marker_white_alt.png';
import decreeMarkerWhiteAltOutlined from '../../assets/decree_marker_white_alt_outline.png';
import decreeMarkerBlack from '../../assets/decree_marker_black.png';
import decreeMarkerBlackOutlined from '../../assets/decree_marker_black_outline.png';
import decreeMarkerBlackAlt from '../../assets/decree_marker_black_alt.png';
import decreeMarkerBlackAltOutlined from '../../assets/decree_marker_black_alt_outline.png';

export default {
    name: 'DecreeMarker',
    props: [
        'theme',
        'color',
        'selected',
    ],
    data() {
        return {
            black: {
                default: decreeMarkerBlack,
                defaultOutlined: decreeMarkerBlackOutlined,
                alt: decreeMarkerBlackAlt,
                altOutlined: decreeMarkerBlackAltOutlined,
            },
            white: {
                default: decreeMarkerWhite,
                defaultOutlined: decreeMarkerWhiteOutlined,
                alt: decreeMarkerWhiteAlt,
                altOutlined: decreeMarkerWhiteAltOutlined,
            },
        };
    },
    computed: {
        decreeMarkerImg(color, theme, selected) {
            if (this.theme === THEME_TOURNAMENT_KIT) {
                if (this.selected) {
                    return this[this.color].altOutlined;
                }

                return this[this.color].alt;
            }

            if (this.selected) {
                return this[this.color].defaultOutlined;
            }

            return this[this.color].default;
        },
    },
};
</script>

<style scoped lang="scss">

</style>
